import get from 'lodash/get'
import { connect } from 'react-redux'
import ActivityInclusions from './ActivityInclusions'
import PriceConverter from '../helpers/PriceConverter'

import './adventure-card.scss'
import AvailableDates from './AvailableDate'
import InstantConfirmation from './InstantConfirmation'
import { WishlistButton } from '../helpers'
import AdventureOriginalTitle from './AdventureOriginalTitle'
import { useMemo } from 'react'
import { trackGA4Ecommerce } from '../../gtm'
import { target } from '../../utils'

function AdventureCard({ adventure, isWidget }) {
  const picture = get(adventure, 'picture["800x800"]', '')
  const currency = get(adventure, 'minimumPrice.originCurrency')
  const compareAtPrice = get(adventure, 'compareAtPrice.originValue')
  const price = get(adventure, 'minimumPrice.originValue')

  const handleClick = () => {
    if(adventure.viewItem) {
      trackGA4Ecommerce('select_item', {
        currency: 'USD',
        items: [adventure.viewItem],
      }, 'PADI Travel - Adventures')
    }
    window.parent.postMessage({
      source: 'padi-widget',
      type: 'reset',
    }, '*')
  }

  const queryParams = useMemo(() => {
    const queries = new URLSearchParams(window.location.search)
    queries.delete('travel_widget_entry')
    queries.delete('widget')
    queries.delete('activity_date')
    queries.delete('participants')

    if(window.isAdventuresOnly) {
      queries.append('travel_widget_entry', 'widget_adventures')
    }
    if(isWidget) {
      queries.append('widget', 'true')
    }

    return queries.toString()
  }, [isWidget])

  return (
    <div className='adventure-card'>
      <a
        href={`${adventure.activityPage}${
          queryParams ? `&${queryParams}` : ''
        }`}
        onClick={handleClick}
        className='adventure-url'
      />
      <div className='img-wrapper'>
        <img
          src={picture}
          className='img'
          alt='adventure card'
          loading='lazy'
        />
        {!isWidget && (
          <WishlistButton
            isInWishlist={adventure.inDefaultWishlist}
            type='Activity'
            id={adventure.id}
          />
        )}
      </div>

      <div className='info'>
        <strong className='adventure-card__title'>
          {adventure.title}
          <AdventureOriginalTitle
            originalTitle={adventure.originalTitle}
            title={adventure.title}
          />
        </strong>
        <p className='dive-center-title'>{adventure.diveCenterTitle}</p>
        <p className='adventure-card__inclusion'>
          <ActivityInclusions item={adventure} />
        </p>
        <p className='adventure-card__availability'>
          <AvailableDates date={adventure.availableDate} />
        </p>
        <div className='adventure-card__price'>
          {compareAtPrice > price && (
            <span className='old-pricing'>
              <PriceConverter
                amount={compareAtPrice}
                currency={currency}
                conversionPercent
              />
            </span>
          )}
          <span className='pricing'>
            <PriceConverter
              amount={price}
              currency={currency}
              conversionPercent
            />
            {adventure.instantConfirmation && <InstantConfirmation />}
          </span>
        </div>
      </div>
    </div>
  )
}

export default connect((state) => ({
  selectedCurrency: state.selectedCurrency,
}))(AdventureCard)
